<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <avs-button
        v-bind="{ ...attrs, ...$attrs }"
        v-on="{ ...on, ...$listeners }"
        color="error"
        dense
        fab
        icon
        iconI="mdi-account-arrow-right-outline"
        label
        small
        :disabled="disabled"
      />
    </template>
    <span>{{ spantext }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "LeaveButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    spantext: {
      type: String
    }
  }
}
</script>
